import { initialTimeFormat, TimeFormatOptions, User } from '@griply/types';

export const getTimeFormat = (user?: User | null): TimeFormatOptions =>
  user?.settings?.timeFormat ?? initialTimeFormat;
